var redirect = function redirect(source) {
  var uri;
  var isModal = source.indexOf('modal');
  isModal >= 0 ? uri = source.replace('modal', 'redirect') : uri = source;
  if (navigator.userAgent.match(/Android/i)) document.location = uri;else window.location.href = uri;
};
export default redirect;